<template>
  <div>
    <ed-modal 
      :title="formData.id == 0 ? 'Novo Email' : 'Editar Email'" 
      :modal="showFormEdit" 
      :loadingSave="config.loading.save"
      :onSave="salvar"
      width="95%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <details
          v-for="(grupo, index) in gruposForm"
          :key="index"
          :open="grupo.group === 'Geral'"
          class="mb-4 border rounded p-3"
        >
          <summary class="cursor-pointer font-weight-bold text-lg mb-2">
            {{ grupo.group }}
          </summary>

          <template v-if="grupo.group === 'Tipo de Autenticação'">
            <ed-form
              :data="formData"
              :config="config"
              :response="response"
              :itens="grupo.fields"
            />
            
            <div v-if="formData.tipo_auth === 'oauth2'" class="mt-3">
              <div class="alert alert-info">
                <h6><i class="fas fa-info-circle"></i> Gmail OAuth2</h6>
                <p class="mb-2">
                  Para usar Gmail OAuth2, você precisa apenas autorizar sua conta. 
                  As credenciais OAuth2 já estão configuradas no sistema.
                </p>
              </div>
              
              <div v-if="formData.id" class="mt-3">
                <button 
                  class="btn btn-primary mr-2" 
                  @click.prevent="conectarOAuth2"
                  :disabled="config.loading.oauth"
                >
                  <span v-if="config.loading.oauth" class="spinner-border spinner-border-sm mr-2"></span>
                  🔗 Autorizar Conta Gmail
                </button>
                
                <button 
                  class="btn btn-info btn-sm ml-2" 
                  @click.prevent="verificarStatusOAuth2"
                  :disabled="config.loading.status"
                >
                  <span v-if="config.loading.status" class="spinner-border spinner-border-sm mr-2"></span>
                  📊 Verificar Status
                </button>
              </div>
              
              <div v-else class="alert alert-warning mt-3">
                <small><i class="fas fa-save"></i> Salve a conta primeiro para poder autorizar o Gmail OAuth2</small>
              </div>

              <!-- Link para abrir modal do termo -->
              <div class="mt-3 text-muted small">
                <p>
                  Ao autorizar, você concorda com o envio automatizado de e-mails relacionados à medicina do trabalho. 
                  <a href="#" @click.prevent="abrirTermoModal" style="text-decoration: underline; cursor: pointer;">
                    Leia o termo de consentimento completo.
                  </a>
                </p>
              </div>
              
              <div v-if="oauthStatus" class="mt-3">
                <div v-if="oauthStatus.is_fully_configured" class="alert alert-success">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <strong>✅ Gmail conectado com sucesso!</strong>
                      <br><small>Sua conta está autorizada e funcionando</small>
                    </div>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-outline-danger"
                      @click="revogarOAuth2"
                    >
                      Desconectar
                    </button>
                  </div>
                </div>
                
                <div v-else-if="!oauthStatus.has_tokens" class="alert alert-warning">
                  <strong>⚠️ Autorização pendente</strong>
                  <br><small>Clique em "Autorizar Conta Gmail" para conectar</small>
                </div>
                
                <div v-else class="alert alert-danger">
                  <strong>❌ Erro na autorização</strong>
                  <br><small>Tente autorizar novamente</small>
                </div>
              </div>
            </div>
          </template>

          <template v-else-if="grupo.group === 'Configurações SMTP'">
            <div v-show="!formData.tipo_auth || formData.tipo_auth === 'senha'">
              <div v-if="formData.tipo_auth === 'oauth2'" class="alert alert-info mb-3">
                <i class="fas fa-info-circle"></i> 
                Configurações SMTP não são necessárias para Gmail OAuth2
              </div>
              <ed-form
                :data="formData"
                :config="config"
                :response="response"
                :itens="grupo.fields"
              />
            </div>
            <div v-if="formData.tipo_auth === 'oauth2'" class="alert alert-secondary">
              <i class="fas fa-shield-alt"></i>
              <strong>Gmail OAuth2 selecionado</strong><br>
              <small>As configurações SMTP não são necessárias. A autenticação será feita diretamente com o Google.</small>
            </div>
          </template>

          <template v-else>
            <ed-form
              :data="formData"
              :config="config"
              :response="response"
              :itens="grupo.fields"
            />
          </template>
        </details>
      </div>
    </ed-modal>

    <!-- Modal Termo de Consentimento -->
    <ed-modal
      title="Termo de Consentimento"
      :modal="showTermoModal"
      width="600px"
      @close="fecharTermoModal"
    >
      <div slot="modal-content" style="max-height: 400px; overflow-y: auto; white-space: pre-wrap; padding: 1rem; font-size: 0.95rem; line-height: 1.5;">
        <p>
          Ao conectar sua conta Gmail via OAuth2, você concorda expressamente que este sistema poderá enviar automaticamente mensagens de e-mail relacionadas às atividades profissionais, 
          incluindo comunicações sobre exames médicos, agendamentos e outras informações pertinentes à medicina do trabalho.
        </p>
        <p>
          O envio desses e-mails tem como objetivo otimizar a comunicação entre a clínica de medicina do trabalho e os colaboradores, garantindo o cumprimento das normas legais e a segurança dos processos internos.
        </p>
        <p>
          Todos os dados são tratados com rigorosa confidencialidade, em conformidade com a legislação aplicável de proteção de dados pessoais.
        </p>
        <p>
          Caso não concorde com este termo, recomendamos que não prossiga com a autorização da conta Gmail via OAuth2.
        </p>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from 'common/rest';
import EdForm from 'common/form';
import EdModal from 'common/modal';
import FormItems from './_form/email-cadastrar';

export default {
  name: 'exame-editar',
  components: { 
    EdForm, 
    EdModal
  },
  mixins: [Rest],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm(val) {
      this.showFormEdit = val;
      if (val) this.init();
    }
  },
  data() {
    return {
      config: {
        tipo: [240, 32, 241], 
        tipo_exclude: [33, 34, 35, 36, 37, 196],
        hidden: { padrao: true },
        click: {},
        loading: { 
          save: false, 
          content: false,
          oauth: false,
          status: false
        },
        list: {}
      },
      formData: {
        id: 0,
        nome: null,
        usuario: null,
        email: null,
        servidor_smtp: null,
        autenticacao: 1,
        conexao_seg: 'tls',
        senha: null,
        porta: 0,
        tempo_espera: 0,
        n_msg_pct: 50,
        t_esp_pct: 600,
        updated_at: null,
        tipo: [],
        tipo_auth: 'senha'
      },
      response: {},
      showFormEdit: false,
      gruposForm: [],
      oauthStatus: null,
      showTermoModal: false
    };
  },
  mounted() {
    this.gruposForm = FormItems;
  },
  methods: {
    abrirTermoModal() {
      if (this.showTermoModal) {
        this.showTermoModal = false;
        this.$nextTick(() => {
          this.showTermoModal = true;
        });
      } else {
        this.showTermoModal = true;
      }
    },
    
    fecharTermoModal() {
      this.showTermoModal = false;
    },
    
    // Seus métodos existentes (init, salvar, validarFormulario, conectarOAuth2, verificarStatusOAuth2, revogarOAuth2)

    init() {
      this.response = {};
      this.oauthStatus = null;
      
      if (!this.parent || !this.parent.formData) return;

      const tipo = Array.isArray(this.parent.formData.tipo)
        ? this.parent.formData.tipo.map(element => element.id)
        : [];

      this.formData = {
        id: this.parent.formData.id || 0,
        nome: this.parent.formData.nome || null,
        usuario: this.parent.formData.usuario || null,
        email: this.parent.formData.email || null,
        servidor_smtp: this.parent.formData.servidor_smtp || null,
        autenticacao: this.parent.formData.autenticacao || 1,
        conexao_seg: this.parent.formData.conexao_seg || 'tls',
        porta: this.parent.formData.porta || 0,
        senha: null,
        tempo_espera: this.parent.formData.tempo_espera || 0,
        n_msg_pct: this.parent.formData.n_msg_pct || 50,
        t_esp_pct: this.parent.formData.t_esp_pct || 600,
        updated_at: this.parent.formData.updated_at || null,
        tipo,
        tipo_auth: this.parent.formData.tipo_auth || 'senha'
      };
      
      if (this.formData.tipo_auth === 'oauth2' && this.formData.id) {
        this.verificarStatusOAuth2();
      }
    },

    salvar() {
      this.response = {};
      this.config.loading.save = true;

      if (!this.validarFormulario()) {
        this.config.loading.save = false;
        return;
      }

      this.post('conta-email/editar', this.formData).then((result) => {
        result = result[0];
        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg('Registro salvo com sucesso!');
          
          if (this.formData.id === 0 && result.data && result.data.id) {
            this.formData.id = result.data.id;
          }
          
          if (this.formData.tipo_auth === 'oauth2' && this.formData.id) {
            setTimeout(() => {
              this.verificarStatusOAuth2();
            }, 500);
          }
          
          this.showFormEdit = false;

          if (this.parent && this.parent.getContaEmail) {
            this.parent.getContaEmail();
          }
        }
      }).catch(() => {
        this.config.loading.save = false;
      });
    },

    validarFormulario() {
      if (!this.formData.nome) {
        this.edMsg('Nome é obrigatório', 'error');
        return false;
      }
      
      if (!this.formData.email) {
        this.edMsg('Email é obrigatório', 'error');
        return false;
      }
      
      if (!this.formData.usuario) {
        this.edMsg('Usuário é obrigatório', 'error');
        return false;
      }
      
      if (!this.formData.tipo_auth) {
        this.edMsg('Método de Autenticação é obrigatório', 'error');
        return false;
      }

      if (this.formData.tipo_auth === 'senha') {
        if (!this.formData.senha && this.formData.id === 0) {
          this.edMsg('Senha é obrigatória para contas SMTP', 'error');
          return false;
        }
        
        if (!this.formData.servidor_smtp) {
          this.edMsg('Servidor SMTP é obrigatório para contas SMTP', 'error');
          return false;
        }
        
        if (!this.formData.porta) {
          this.edMsg('Porta é obrigatória para contas SMTP', 'error');
          return false;
        }
        
        if (!this.formData.conexao_seg) {
          this.edMsg('Conexão de Segurança é obrigatória para contas SMTP', 'error');
          return false;
        }
      }

      if (this.formData.tipo_auth === 'oauth2') {
        console.log('Validação OAuth2: apenas campos básicos necessários');
      }

      return true;
    },

    async conectarOAuth2() {
      if (!this.formData.id) {
        this.edMsg('Salve a conta primeiro antes de conectar OAuth2', 'warning');
        return;
      }

      try {
        this.config.loading.oauth = true;
        
        const response = await this.get(`conta-email/${this.formData.id}/oauth2/iniciar`);
        
        if (response && response[0] && response[0].data && response[0].data.auth_url) {
          const popup = window.open(
            response[0].data.auth_url,
            'oauth2',
            'width=500,height=600,scrollbars=yes,resizable=yes'
          );
          
          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              setTimeout(() => {
                this.verificarStatusOAuth2();
              }, 1000);
            }
          }, 1000);
        } else {
          this.edMsg('Erro ao obter URL de autorização', 'error');
        }
        
      } catch (error) {
        console.error('Erro ao conectar OAuth2:', error);
        this.edMsg('Erro ao iniciar conexão OAuth2', 'error');
      } finally {
        this.config.loading.oauth = false;
      }
    },

    async verificarStatusOAuth2() {
      if (!this.formData.id || this.formData.tipo_auth !== 'oauth2') {
        return;
      }

      try {
        this.config.loading.status = true;
        
        const response = await this.get(`conta-email/${this.formData.id}/oauth2/status`);
        
        if (response && response[0] && response[0].data) {
          this.oauthStatus = response[0].data;
          
          if (this.oauthStatus.is_fully_configured) {
            this.edMsg('OAuth2 configurado com sucesso!', 'success');
          }
        }
        
      } catch (error) {
        console.error('Erro ao verificar status OAuth2:', error);
        this.oauthStatus = null;
      } finally {
        this.config.loading.status = false;
      }
    },

    async revogarOAuth2() {
      if (!confirm('Tem certeza que deseja desconectar a conta Gmail?')) {
        return;
      }

      try {
        await this.post(`conta-email/${this.formData.id}/oauth2/revogar`, {});
        this.oauthStatus = null;
        this.edMsg('Conta Gmail desconectada com sucesso!', 'success');
        
        setTimeout(() => {
          this.verificarStatusOAuth2();
        }, 500);
        
      } catch (error) {
        console.error('Erro ao revogar OAuth2:', error);
        this.edMsg('Erro ao desconectar conta Gmail', 'error');
      }
    }
  }
};
</script>

<style scoped>
summary {
  cursor: pointer;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
details[open] > summary {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// editar.vue?faee9eec